import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const OpenMobileAppStyled = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    background-color: var(--background-base);
    background-image: url(${`${process.env.PUBLIC_URL}/assets/open-app/page-background.svg`});
    background-position: center;
    position: relative;
    padding: 16px;
    justify-content: center;
    align-items: center;
`;

export const OpenMobileAppCloseButtonStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 24px;
    left: 16px;
    font-size: 16px;
    cursor: pointer;
    
    svg {
        fill: var(--color-white-60);
    }
`;

export const OpenMobileAppContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    width: 400px;
    background: var(--color-surface);
    border-radius: 16px;
    
    h1 {
        font-size: 40px;
    }
    .google-button {
        background: var(--color-neutral-20);
        justify-content: center;
        border-radius: 16px;
        margin-top: 64px;
    }

    @media (max-width: ${BREAKPOINTS.small}px) {
        width: 100%;
    }
`;

export const OpenMobileAppLogoContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 80px;
    background: var(--background-logo);
    border-radius: 16px;
`;

// export const
